/* eslint-disable no-redeclare */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import axios from "axios";
import moment from "moment";
import API_URL from "../../constants/API_URL";
import Swal from "sweetalert2";
import QRCode from "qrcode";

let sendDynamicPrintToServer = async (_data, type) => {
  try {
    const branch = JSON.parse(localStorage.getItem("branch_data") || "{}");
    const clientId = localStorage.getItem("clientId");

    const payload = {
      clientId: String(clientId),
      branch: String(branch.id),
      printType: type,
      invoice:
        type === "ORDER_RECEIPT" ||
        type === "KITCHEN" ||
        type === "REFUND" ||
        type === "CHECK_PRINT" ||
        type === "DUPLICATE"
          ? _data
          : null,
      barcode: type === "BARCODE" ? _data : null,
      cashup: type === "CASHUP" ? _data : null,
    };

    const { data } = await axios({
      url: API_URL + "kafka/publishPrint",
      method: "POST",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return data;
    console.log("✅ Sent successfully:", data);
  } catch (error) {
    console.log("❌ API Error:", error);
  }
};

let sendKitchenPrintToServer = async (data) => {
  await sendDynamicPrintToServer(data, "KITCHEN");
};

let sendRefundPrintToServer = async (data, ip) => {
  await sendDynamicPrintToServer(data, "REFUND");
};

let createKitchenSlip = async (dataPrint, param, isPrntKitchenOnPayment) => {
  if (dataPrint.data.isPrntBarcode && dataPrint.branch.isBarcodeEnable) {
    let newLines = [];
    let productList = [
      ...dataPrint.posProductList.filter(
        (item) => item.isBarcodeProduct == true,
      ),
    ];
    let lines;
    if (param === "cancelItemInKitchen") {
      lines = dataPrint.line.filter((item) => item.status == "C");
    } else {
      if (isPrntKitchenOnPayment) {
        lines = dataPrint.line.filter((item) => item.status != "C");
      } else {
        lines = dataPrint.line.filter((item) => item.status == "DR");
      }
    }
    console.log(lines);
    lines.map((item) => {
      if (
        item.isGroupItem == false &&
        item.isAddProduct == false &&
        productList.length > 0 &&
        productList.filter((i) => i.id === item.product).length > 0 &&
        productList.filter((i) => i.id === item.product)[0].isBarcodeProduct
      ) {
        let newlineschild = [];
        lines.forEach((ii) => {
          if (item.isGroupItem == false || item.isAddProduct == false) {
            if (ii.parentProduct == item.id) {
              let nameAr =
                productList.length > 0 &&
                productList.filter((i) => i.id === ii.product).length > 0 &&
                productList.filter((i) => i.id === ii.product)[0].nameAr
                  ? productList.length > 0 &&
                    productList.filter((i) => i.id === ii.product).length > 0 &&
                    productList.filter((i) => i.id === ii.product)[0].nameAr
                  : "";
              let name =
                productList.length > 0 &&
                productList.filter((i) => i.id === ii.product).length > 0 &&
                productList.filter((i) => i.id === ii.product)[0].name
                  ? productList.length > 0 &&
                    productList.filter((i) => i.id === ii.product).length > 0 &&
                    productList.filter((i) => i.id === ii.product)[0].name
                  : "";
              newlineschild.push({ name, nameAr, qty: ii.qty });
            }
          }
        });
        let nameAr =
          productList.length > 0 &&
          productList.filter((i) => i.id === item.product).length > 0 &&
          productList.filter((i) => i.id === item.product)[0].nameAr
            ? productList.filter((i) => i.id === item.product)[0].nameAr
            : "";
        let name =
          productList.length > 0 &&
          productList.filter((i) => i.id === item.product).length > 0 &&
          productList.filter((i) => i.id === item.product)[0].name
            ? productList.filter((i) => i.id === item.product)[0].name
            : "";
        newLines.push({ name, nameAr, qty: item.qty });
      }
    });
    let data = {
      orderNo: dataPrint.orderNo,
      printer: dataPrint.data.name,
      products: [...newLines],
      clientName: localStorage.getItem("client_name"),
    };
    await sendDynamicPrintToServer(data, "BARCODE");
  }
  let newLines = [];
  if (dataPrint.data.isPrntAllCat) {
    let lines;
    if (param === "cancelItemInKitchen") {
      lines = dataPrint.line.filter((item) => item.status == "C");
    } else {
      if (isPrntKitchenOnPayment) {
        lines = dataPrint.line.filter((item) => item.status != "C");
      } else {
        lines = dataPrint.line.filter((item) => item.status == "DR");
      }
    }
    lines.map((item) => {
      if (item.isGroupItem == false && item.isAddProduct == false) {
        let newlineschild = [];
        lines.forEach((ii) => {
          if (item.isGroupItem == false || item.isAddProduct == false) {
            if (ii.parentProduct == item.id) {
              let nameAr =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0]
                  .nameAr
                  ? dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .nameAr
                  : "";
              let name =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0].name
                  ? dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .name
                  : "";
              newlineschild.push({ name, nameAr, qty: ii.qty });
            }
          }
        });
        let nameAr =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].nameAr
            ? dataPrint.productList.filter((i) => i.id === item.product)[0]
                .nameAr
            : "";
        let name =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].name
            ? dataPrint.productList.filter((i) => i.id === item.product)[0].name
            : "";
        newLines.push({
          notes: item.notes,
          name,
          nameAr,
          qty: item.qty,
          items: [...newlineschild],
        });
      }
    });
    console.log("newLines", newLines);
    var data = {
      header: dataPrint.header,
      footer: dataPrint.footer,
      orderNo: dataPrint.orderNo,
      floorName: dataPrint.floorName
        ? dataPrint.floorName
        : localStorage.getItem("floorName"),
      tableName: dataPrint.tableName
        ? dataPrint.tableName
        : localStorage.getItem("tableName"),
      printer: dataPrint.data.name,
      lines: [...newLines],
      tokenNo: dataPrint.tokenNo,
      cancel: false,
    };
    if (param === "cancelItemInKitchen") {
      data.cancel = true;
    }

    sendKitchenPrintToServer(data, dataPrint.data.ipAddr);
  } else {
    let lines;
    if (param === "cancelItemInKitchen") {
      lines = dataPrint.line.filter((item) => item.status == "C");
    } else {
      if (isPrntKitchenOnPayment) {
        lines = dataPrint.line.filter((item) => item.status != "C");
      } else {
        lines = dataPrint.line.filter((item) => item.status == "DR");
      }
    }
    for (let it = 0; it <= dataPrint.data.categories.length - 1; it++) {
      // eslint-disable-next-line no-loop-func

      lines.map((item) => {
        if (item.isGroupItem == false && item.isAddProduct == false) {
          let comp = dataPrint.data.categories[it];
          let comp1 =
            dataPrint.posProductList.length > 0 &&
            dataPrint.posProductList.filter((i) => i.id === item.product)
              .length > 0 &&
            dataPrint.posProductList.filter((i) => i.id === item.product)[0]
              .categoryId;
          if (comp == comp1) {
            let newlineschild = [];
            lines.forEach((ii) => {
              if (item.isGroupItem == false || item.isAddProduct == false) {
                if (ii.parentProduct == item.id) {
                  let nameAr =
                    dataPrint.productList.length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)
                      .length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .nameAr
                      ? dataPrint.productList.filter(
                          (i) => i.id === ii.product,
                        )[0].nameAr
                      : "";
                  let name =
                    dataPrint.productList.length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)
                      .length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .name
                      ? dataPrint.productList.filter(
                          (i) => i.id === ii.product,
                        )[0].name
                      : "";
                  newlineschild.push({ name, nameAr, qty: ii.qty });
                }
              }
            });
            let nameAr =
              dataPrint.productList.length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)
                .length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)[0]
                .nameAr
                ? dataPrint.productList.filter((i) => i.id === item.product)[0]
                    .nameAr
                : "";
            let name =
              dataPrint.productList.length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)
                .length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)[0].name
                ? dataPrint.productList.filter((i) => i.id === item.product)[0]
                    .name
                : "";
            newLines.push({
              notes: item.notes,
              name,
              nameAr,
              qty: item.qty,
              items: [...newlineschild],
            });
          }
        }
      });
    }
    if (newLines.length > 0) {
      var data = {
        header: dataPrint.header,
        footer: dataPrint.footer,
        orderNo: dataPrint.orderNo,
        floorName: dataPrint.floorName
          ? dataPrint.floorName
          : localStorage.getItem("floorName"),
        tableName: dataPrint.tableName
          ? dataPrint.tableName
          : localStorage.getItem("tableName"),
        printer: dataPrint.data.name,
        lines: [...newLines],
        customer: dataPrint.customer,
        tokenNo: dataPrint.tokenNo,
        cancel: false,
      };
      if (param === "cancelItemInKitchen") {
        data.cancel = true;
      }
      sendKitchenPrintToServer(data, dataPrint.data.ipAddr);
    }
  }
};

let createRefundSlip = (dataPrint) => {
  let totalWithoutTax = 0;
  let total = 0;
  let newLines = [];
  let lines = dataPrint.line;
  lines.map((item) => {
    // console.log(item)
    if (item.refundQty > 0 && item.isComboChild == false) {
      let pp, name, nameAr, price;
      console.log(item);
      if (item.isCombo) {
        pp = item.priceWithoutTax;
        price = item.unitPrice;
        nameAr =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].nameAr;
        name =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].name;
        // console.log(pp, name, nameAr)
      } else {
        price = item.unitPrice;
        pp = item.priceWithoutTax;
        nameAr =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].nameAr;
        name =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].name;
      }
      totalWithoutTax = totalWithoutTax + pp * item.refundQty;
      total = total + price * item.refundQty;
      newLines.push({
        name: name,
        nameAr: nameAr,
        qty: item.refundQty,
        // priceWithoutTax: pp * item.refundQty,
        priceWithoutTax: pp,
        totalNetLine: parseFloat((item.unitPrice * item.refundQty).toFixed(2)),
        unitPrice: item.unitPrice,
        // items: [...newlineschild]
        items: [],
      });
    }
  });
  // console.log(newLines)
  // let paymeAmount = dataPrint.paymeAmount  ? dataPrint.paymeAmount  : 0
  var data = {
    header: dataPrint.header,
    footer: dataPrint.footer,
    orderNo: dataPrint.orderNo,
    floorName: dataPrint.floorName
      ? dataPrint.floorName
      : localStorage.getItem("floorName"),
    tableName: dataPrint.tableName
      ? dataPrint.tableName
      : localStorage.getItem("tableName"),
    printer: dataPrint.data.name,
    lines: [...newLines],
    cashier: JSON.parse(localStorage.getItem("userData")).name,
    //   totalWithoutTax: parseFloat(totalWithoutTax),
    tax: dataPrint.tax,
    total: total,
    // customerPayAmount:  parseFloat((paymeAmount).toFixed(2)) ,
    // remainingAmount: parseFloat((- dataPrint.totalNet + parseFloat((paymeAmount).toFixed(2))).toFixed(2)),
    refund: dataPrint.refundAmount,
    customer: dataPrint.customer,
    tokenNo: dataPrint.tokenNo,
  };
  data.taxNo = localStorage.getItem("taxNo")
    ? localStorage.getItem("taxNo")
    : "";
  console.log(data);
  sendRefundPrintToServer(data, dataPrint.data.ipAddr);
};

let sendPaymentPrintToServer = async (datA, ip, param) => {
  const data = { ...datA };
  const tobacco = JSON.parse(
    localStorage.getItem("saveSaleOrderTobacco") || "{}",
  );
  let url;
  data.tobaccoFeeBeforeTax = tobacco.netLineWithoutTax;
  data.tobaccoFeeAfterTax = tobacco.totalNetLine;
  data.tax = Number(localStorage.getItem("totalTax"));
  console.log("param ----------------->", param);

  if (param == "payment" || param == "rPrint") {
    url = "ORDER_RECEIPT";
  }
  if (param == "cPrint") {
    url = "CHECK_PRINT";
  }
  if (param == "cDuplicate") {
    url = "DUPLICATE";
  }
  await sendDynamicPrintToServer(data, url);
};

let createReceiptSlip = (dataPrint, param) => {
  let totalWithoutTax = 0;
  let newLines = [];
  let lines = dataPrint.line.filter((i) => i.status != "C");
  lines.map((item) => {
    if (
      item.isGroupItem == false &&
      item.isAddProduct == false &&
      item.isComboChild == false
    ) {
      let newlineschild = [];
      lines.forEach((ii) => {
        if (
          item.isGroupItem == false ||
          item.isAddProduct == false ||
          item.isComboChild == false
        ) {
          if (ii.parentProduct == item.id) {
            if (ii.isComboChild == false) {
              let pp;
              pp = ii.priceWithoutTax;
              totalWithoutTax = totalWithoutTax + pp * ii.qty;
              console.log(totalWithoutTax);
              let nameAr =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0]
                  .nameAr;
              let name =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0]
                  .name;
              newlineschild.push({
                name: name,
                nameAr: nameAr,
                // priceWithoutTax: pp * ii.qty,
                priceWithoutTax: pp,
                qty: ii.qty,
                totalNetLine: parseFloat(ii.totalNetLine.toFixed(2)),
                unitPrice: ii.unitPrice,
              });
            }
          }
        }
      });
      let pp, nameAr, name;
      if (item.combo) {
        pp = item.priceWithoutTax;
        nameAr =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].nameAr;
        name =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].name;
      } else {
        pp = item.priceWithoutTax;
        nameAr =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].nameAr;
        name =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].name;
      }
      totalWithoutTax = totalWithoutTax + pp * item.qty;
      newLines.push({
        name: name,
        nameAr: nameAr,
        qty: item.qty,
        // priceWithoutTax: pp * item.qty,
        priceWithoutTax: pp,
        totalNetLine: parseFloat(item.totalNetLine.toFixed(2)),
        unitPrice: item.unitPrice,
        items: [...newlineschild],
      });
    }
  });
  let paymeAmount = dataPrint.paymeAmount ? dataPrint.paymeAmount : 0;
  let totalAnount = 0;
  if (param == "rPrint" || param == "cDuplicate") {
    totalAnount = dataPrint.totalNet;
  } else {
    totalAnount = dataPrint.actualAmt;
  }

  let cashPaidAmount = dataPrint.cashPaidAmount ? dataPrint.cashPaidAmount : 0;

  var data = {
    header: dataPrint.header,
    footer: dataPrint.footer,
    orderNo: dataPrint.orderNo,
    deliveryPerson: dataPrint.deliveryPerson,
    orderType: dataPrint.orderType,
    floorName: dataPrint.floorName
      ? dataPrint.floorName
      : localStorage.getItem("floorName"),
    tableName: dataPrint.tableName
      ? dataPrint.tableName
      : localStorage.getItem("tableName"),
    printer: dataPrint.data.name,
    lines: [...newLines],
    totalWithoutTax: parseFloat(totalWithoutTax),
    tax: dataPrint.taxAmt,
    taxAmt: dataPrint.taxAmt,
    total: dataPrint.totalNet.toFixed(2),
    customerPayAmount: parseFloat(dataPrint.payCash),
    remainingAmount: 0,
    cashier: JSON.parse(localStorage.getItem("userData")).name,
    customer: dataPrint.customer,
    tokenNo: dataPrint.tokenNo,
    couponNo: dataPrint.couponNo,
    discountAmt: dataPrint.discountAmt,
    actualAmt: dataPrint.actualAmt,
    extraCharge: 0,
    paidAmt: dataPrint.paidAmt,
    orderId: dataPrint.orderId,
    qrcode: dataPrint.qrcode,
    address: dataPrint.address,
    branch: dataPrint.branch,
  };
  if (param == "rPrint" || param == "cPrint" || param == "cDuplicate") {
    data.orderDate = moment(dataPrint.orderDate).format("YYYY-MM-DD hh:mm A");
  }
  if (parseFloat(dataPrint.payCash) > parseFloat(cashPaidAmount)) {
    data.remainingAmount = parseFloat(
      (parseFloat(dataPrint.payCash) - parseFloat(cashPaidAmount)).toFixed(2),
    );
  }
  if (dataPrint.isMinCharge && dataPrint.paidAmt > dataPrint.actualAmt) {
    data.extraCharge = (dataPrint.paidAmt - dataPrint.actualAmt).toFixed(2);
    if (dataPrint.isTaxOnChrg) {
      let tax = data.extraCharge * (dataPrint.taxRate / 100);
      data.tax = (data.tax + tax).toFixed(2);
    }
  }
  data.taxNo = localStorage.getItem("taxNo")
    ? localStorage.getItem("taxNo")
    : "";

  sendPaymentPrintToServer(data, dataPrint.data.ipAddr, param);
};

export const buildMessage = async (
  line,
  data,
  productList,
  tables,
  floors,
  printer_models,
  param,
  paymeAmount,
  customerList,
  cashPaidAmount,
  comboList,
  posProductListForKitchen,
  posStorageAction,
  isPrntKitchenOnPayment,
  deliveryPerson,
  onReset,
) => {
  var tableName =
    tables.length > 0 &&
    tables.filter((i) => i.id === data.flrTable).length > 0 &&
    tables.filter((i) => i.id === data.flrTable)[0].name;
  var floor =
    tables.length > 0 &&
    tables.filter((i) => i.id === data.flrTable).length > 0 &&
    tables.filter((i) => i.id === data.flrTable)[0].floor;
  var floorName =
    floors.length > 0 &&
    floors.filter((i) => i.id === floor).length > 0 &&
    floors.filter((i) => i.id === floor)[0].name;
  var customer =
    customerList.length > 0 &&
    customerList.filter((i) => i.id == data.customer).length > 0 &&
    customerList.filter((i) => i.id == data.customer)[0].name;

  if (tableName) await localStorage.setItem("tableName", tableName);
  if (floorName) await localStorage.setItem("floorName", floorName);

  if (param == "payment") {
    Swal.fire({
      title: "هل تريد الطباعة",
      text: "تم إتمام عملية الدفع بنجاح",
      icon: "success",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "نعم اطبع",
      cancelButtonText: "الغاء",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (param == "payment") {
          await posStorageAction({ pos: true });
          if (onReset) await onReset();
        }
        var branch = JSON.parse(
          JSON.parse(localStorage.getItem("persist:root")).user,
        ).branchId;
        var headerANDfooter = {};
        var qrcode = null;

        await axios({
          url: API_URL + "branchByID",
          method: "GET",
          params: {
            id: branch,
            lang: localStorage.getItem("lang"),
          },
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }).then((result) => {
          headerANDfooter = result.data.object;
        });

        // [Othman] get qr code
        await axios({
          url: API_URL + `zatca-integration/get-QRCode`,
          method: "POST",
          params: {
            orderId: data.id,
          },
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        })
          .then((resQr) => {
            qrcode = resQr.data.object;
          })
          .catch((err) => {
            console.log("error from get qr code");
          });

        await axios({
          url: API_URL + "printerListByBranch",
          method: "GET",
          params: {
            branchId: branch,
          },
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        })
          .then(async (res) => {
            for (let i = 0; i <= res.data.length - 1; i++) {
              let ot = "";
              if (data.orderType == "TA") {
                ot = "Take Away";
              }
              if (data.orderType == "OL") {
                ot = "Online";
              }
              if (data.orderType == "DI") {
                ot = "Dine In";
              }
              if (data.orderType == "HD") {
                ot = "Home Delivery";
              }
              let isPrntTakeaway = data.orderType == "TA" ? true : false;
              let isPrntOnline = data.orderType == "OL" ? true : false;
              let isPrntDinein = data.orderType == "DI" ? true : false;
              let isPrntDelivery = data.orderType == "HD" ? true : false;
              let ca =
                res.data[i].isPrntDelivery == isPrntDelivery &&
                isPrntDelivery == true;
              let cb =
                res.data[i].isPrntDinein == isPrntDinein &&
                isPrntDinein == true;
              let cc =
                res.data[i].isPrntTakeaway == isPrntTakeaway &&
                isPrntTakeaway == true;
              let co =
                res.data[i].isPrntOnline == isPrntOnline &&
                isPrntOnline == true;
              var printerModel = res.data[i].printerModel;
              var isPrntReciept = res.data[i].isPrntReciept;

              if (ca || cb || cc || co) {
                if (res.data[i].isPrntKitchen) {
                  if (param == "kitchen" || param == "cancelItemInKitchen") {
                    let dataPrint = {
                      header: headerANDfooter.header,
                      footer: headerANDfooter.footer,
                      orderNo: data.documentNo,
                      branch: headerANDfooter,
                      floorName,
                      tableName,
                      data: res.data[i],
                      productList,
                      line,
                      printerModel: printerModel,
                      customer: customer,
                      printer_models: [...printer_models],
                      tokenNo: data.tokenNo,
                      posProductList: posProductListForKitchen,
                    };

                    createKitchenSlip(dataPrint, param, isPrntKitchenOnPayment);
                  }
                }
                if (isPrntReciept) {
                  console.log("#".repeat(40), param);

                  if (
                    param == "payment" ||
                    param == "rPrint" ||
                    param == "cPrint" ||
                    param == "cDuplicate"
                  ) {
                    if (localStorage.getItem("printer") != "null") {
                      if (res.data[i].id != localStorage.getItem("printer")) {
                        continue;
                      }
                    }

                    const branch_data = localStorage.getItem("branch_data");
                    const branch_data_json = JSON.parse(branch_data || "{}");
                    let dataPrint = {
                      header: headerANDfooter.header,
                      footer: headerANDfooter.footer,
                      orderNo: data.documentNo,
                      orderId: data.id,
                      floorName,
                      orderType: ot,
                      orderDate: data.orderDate,
                      deliveryPerson,
                      tableName,
                      totalNet: data.totalNet,
                      data: res.data[i],
                      productList,
                      line,
                      paymeAmount,
                      printerModel: printerModel,
                      printer_models: [...printer_models],
                      customer: customer,
                      tokenNo: data.tokenNo,
                      couponNo: data.couponNo,
                      discountAmt: data.discountAmt,
                      taxAmt: data.taxAmt,
                      actualAmt: data.actualAmt,
                      isMinCharge: data.isMinCharge,
                      minCharge: data.minCharge,
                      paidAmt: data.paidAmt,
                      chargeType: data.chargeType,
                      isTaxOnChrg: data.isTaxOnChrg,
                      taxRate: data.taxRate,
                      payCash: data.payCash,
                      cashPaidAmount: cashPaidAmount,
                      comboList,
                      tax: data.taxAmt,
                      address: branch_data_json.address,
                      branch: branch_data_json.nameAr,
                      qrcode: qrcode,
                    };
                    createReceiptSlip(dataPrint, param);

                    if (headerANDfooter.popupBeforePrint) {
                      const htmlContent = await generateInvoiceHTML(dataPrint);
                      Swal.fire({
                        title: "رسالة تأكيد",
                        html: `
            <div style="max-height: 70vh; overflow-y: auto; text-align: right; direction: rtl;">
              ${htmlContent}
            </div>
          `,
                        showCancelButton: true,
                        showConfirmButton: true,
                        confirmButtonText: "🖨️ طباعة",
                        cancelButtonText: "إلغاء",
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        width: "400px",
                        customClass: {
                          popup: "invoice-popup",
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          const printWindow = window.open("", "_blank");
                          printWindow.document.write(`
              <html>
                <head>
                  <title>فاتورة</title>
                  <style>
                    body { font-family: Arial, sans-serif; direction: rtl; margin: 0; padding: 0; }
                  </style>
                </head>
                <body>
                  ${htmlContent}
                  <script>
                    window.onload = function() {
                      window.print();
                      window.onafterprint = function() { window.close(); }
                    }
                  </script>
                </body>
              </html>
            `);
                          printWindow.document.close();
                        }
                      });
                    }
                  } else if (param == "refund") {
                    let dataPrint = {
                      header: headerANDfooter.header,
                      footer: headerANDfooter.footer,
                      orderNo: data.documentNo,
                      floorName,
                      tableName,
                      totalNet: data.totalNet,
                      data: res.data[i],
                      productList,
                      line,
                      refundAmount: data.refundAmt,
                      printerModel: printerModel,
                      printer_models: [...printer_models],
                      customer: customer,
                      tokenNo: data.tokenNo,
                      tax: data.taxAmt,
                      comboList,
                    };
                    createRefundSlip(dataPrint);
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (result.isDismissed) {
        if (onReset) onReset();
      }
    });
  } else {
    var branch = JSON.parse(
      JSON.parse(localStorage.getItem("persist:root")).user,
    ).branchId;
    var headerANDfooter = {};
    var qrcode = null;
    await axios({
      url: API_URL + "branchByID",
      method: "GET",
      params: {
        id: branch,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((result) => {
      headerANDfooter = result.data.object;
    });

    // [Othman] get qr code
    await axios({
      url: API_URL + `zatca-integration/get-QRCode`,
      method: "POST",
      params: {
        orderId: data.id,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((resQr) => {
        qrcode = resQr.data.object;
      })
      .catch((err) => {
        console.log("error from get qr code");
      });

    var tableName =
      tables.length > 0 &&
      tables.filter((i) => i.id === data.flrTable).length > 0 &&
      tables.filter((i) => i.id === data.flrTable)[0].name;
    var floor =
      tables.length > 0 &&
      tables.filter((i) => i.id === data.flrTable).length > 0 &&
      tables.filter((i) => i.id === data.flrTable)[0].floor;
    var floorName =
      floors.length > 0 &&
      floors.filter((i) => i.id === floor).length > 0 &&
      floors.filter((i) => i.id === floor)[0].name;
    var customer =
      customerList.length > 0 &&
      customerList.filter((i) => i.id == data.customer).length > 0 &&
      customerList.filter((i) => i.id == data.customer)[0].name;

    await axios({
      url: API_URL + "printerListByBranch",
      method: "GET",
      params: {
        branchId: branch,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        for (let i = 0; i <= res.data.length - 1; i++) {
          let ot = "";
          if (data.orderType == "TA") {
            ot = "Take Away";
          }
          if (data.orderType == "OL") {
            ot = "Online";
          }
          if (data.orderType == "DI") {
            ot = "Dine In";
          }
          if (data.orderType == "HD") {
            ot = "Home Delivery";
          }
          let isPrntTakeaway = data.orderType == "TA" ? true : false;
          let isPrntOnline = data.orderType == "OL" ? true : false;
          let isPrntDinein = data.orderType == "DI" ? true : false;
          let isPrntDelivery = data.orderType == "HD" ? true : false;
          let ca =
            res.data[i].isPrntDelivery == isPrntDelivery &&
            isPrntDelivery == true;
          let cb =
            res.data[i].isPrntDinein == isPrntDinein && isPrntDinein == true;
          let cc =
            res.data[i].isPrntTakeaway == isPrntTakeaway &&
            isPrntTakeaway == true;
          let co =
            res.data[i].isPrntOnline == isPrntOnline && isPrntOnline == true;
          var printerModel = res.data[i].printerModel;
          var isPrntReciept = res.data[i].isPrntReciept;

          if (ca || cb || cc || co) {
            if (res.data[i].isPrntKitchen) {
              if (param == "kitchen" || param == "cancelItemInKitchen") {
                let dataPrint = {
                  header: headerANDfooter.header,
                  footer: headerANDfooter.footer,
                  orderNo: data.documentNo,
                  branch: headerANDfooter,
                  floorName,
                  tableName,
                  data: res.data[i],
                  productList,
                  line,
                  printerModel: printerModel,
                  customer: customer,
                  printer_models: [...printer_models],
                  tokenNo: data.tokenNo,
                  posProductList: posProductListForKitchen,
                };
                createKitchenSlip(dataPrint, param, isPrntKitchenOnPayment);
              }
            }
            if (isPrntReciept) {
              console.log("#".repeat(40), param);

              if (
                param == "payment" ||
                param == "rPrint" ||
                param == "cPrint" ||
                param == "cDuplicate"
              ) {
                if (localStorage.getItem("printer") != "null") {
                  if (res.data[i].id != localStorage.getItem("printer")) {
                    continue;
                  }
                }

                const branch_data = localStorage.getItem("branch_data");
                const branch_data_json = JSON.parse(branch_data || "{}");
                let dataPrint = {
                  header: headerANDfooter.header,
                  footer: headerANDfooter.footer,
                  orderNo: data.documentNo,
                  orderId: data.id,
                  floorName,
                  orderType: ot,
                  orderDate: data.orderDate,
                  deliveryPerson,
                  tableName,
                  totalNet: data.totalNet,
                  data: res.data[i],
                  productList,
                  line,
                  paymeAmount,
                  printerModel: printerModel,
                  printer_models: [...printer_models],
                  customer: customer,
                  tokenNo: data.tokenNo,
                  couponNo: data.couponNo,
                  discountAmt: data.discountAmt,
                  taxAmt: data.taxAmt,
                  actualAmt: data.actualAmt,
                  isMinCharge: data.isMinCharge,
                  minCharge: data.minCharge,
                  paidAmt: data.paidAmt,
                  chargeType: data.chargeType,
                  isTaxOnChrg: data.isTaxOnChrg,
                  taxRate: data.taxRate,
                  payCash: data.payCash,
                  cashPaidAmount: cashPaidAmount,
                  comboList,
                  tax: data.taxAmt,
                  address: branch_data_json.address,
                  branch: branch_data_json.nameAr,
                  qrcode: qrcode,
                };
                createReceiptSlip(dataPrint, param);

                if (headerANDfooter.popupBeforePrint) {
                  const htmlContent = await generateInvoiceHTML(dataPrint);
                  Swal.fire({
                    title: "رسالة تأكيد",
                    html: `
          <div style="max-height: 70vh; overflow-y: auto; text-align: right; direction: rtl;">
            ${htmlContent}
          </div>
        `,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "🖨️ طباعة",
                    cancelButtonText: "إلغاء",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    width: "400px",
                    customClass: {
                      popup: "invoice-popup",
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      const printWindow = window.open("", "_blank");
                      printWindow.document.write(`
            <html>
              <head>
                <title>فاتورة</title>
                <style>
                  body { font-family: Arial, sans-serif; direction: rtl; margin: 0; padding: 0; }
                </style>
              </head>
              <body>
                ${htmlContent}
                <script>
                  window.onload = function() {
                    window.print();
                    window.onafterprint = function() { window.close(); }
                  }
                </script>
              </body>
            </html>
          `);
                      printWindow.document.close();
                    }
                  });
                }
              } else if (param == "refund") {
                let dataPrint = {
                  header: headerANDfooter.header,
                  footer: headerANDfooter.footer,
                  orderNo: data.documentNo,
                  floorName,
                  tableName,
                  totalNet: data.totalNet,
                  data: res.data[i],
                  productList,
                  line,
                  refundAmount: data.refundAmt,
                  printerModel: printerModel,
                  printer_models: [...printer_models],
                  customer: customer,
                  tokenNo: data.tokenNo,
                  tax: data.taxAmt,
                  comboList,
                };
                createRefundSlip(dataPrint);
              }
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

export const cashUpPrint = async (data) => {
  var branch = JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user)
    .branchId;
  var headerANDfooter = {};
  await axios({
    url: API_URL + "branchByID",
    method: "GET",
    params: {
      id: branch,
      lang: localStorage.getItem("lang"),
    },
    headers: {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
  }).then((result) => {
    headerANDfooter = result.data.object;
  });
  await axios({
    url: API_URL + "printerListByBranch",
    method: "GET",
    params: {
      branchId: branch,
    },
    headers: {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    for (let i = 0; i <= res.data.length - 1; i++) {
      var isPrntReciept = res.data[i].isPrntReciept;
      if (isPrntReciept) {
        let array = [...data.cashPayments];
        let payments = [];
        let total = 0;
        array.forEach((item) => {
          let obj = {
            paymentAmt: item.paymentAmt,
            name: item.name,
            nameAr: item.nameAr,
          };
          total = total + item.paymentAmt;
          payments.push(obj);
        });
        let cashClosePrint = {
          header: headerANDfooter.header,
          footer: headerANDfooter.footer,
          printer: res.data[i].name,
          branch: data.branch,
          cashupDate: data.cashup.cashupDate,
          closeDate: data.cashup.closeDate,
          total: total,
          payments: [...payments],
        };
        await sendDynamicPrintToServer(cashClosePrint, "CASHUP");
      }
    }
  });
};

const generateQRCodeBase64 = async (value) => {
  console.log("Qr code value", value);
  try {
    return await QRCode.toDataURL(value, {
      errorCorrectionLevel: "M",
      scale: 4,
      margin: 1,
    });
  } catch (err) {
    console.error("QR error:", err);
    return "";
  }
};

const generateInvoiceHTML = async (data, printerWidth = 80) => {
  const lines = Array.isArray(data.line) ? data.line : [];
  const logo = localStorage.getItem("clientLogo");
  const taxNo = localStorage.getItem("taxNo") || "";
  const tobacco = JSON.parse(
    localStorage.getItem("saveSaleOrderTobacco") || "{}",
  );
  const tobaccoFeeBeforeTax = tobacco.netLineWithoutTax;

  const format = (v) => {
    const n = Number(v || 0);
    return isNaN(n) ? "0.00" : n.toFixed(2);
  };

  const hasData = (v) => v !== undefined && v !== null && v !== "" && v !== 0;

  const mainProducts = lines.filter((l) => !l.parentProduct);
  const childrenMap = lines
    .filter((l) => l.parentProduct)
    .reduce((acc, l) => {
      acc[l.parentProduct] = acc[l.parentProduct] || [];
      acc[l.parentProduct].push(l);
      return acc;
    }, {});

  const linesHTML = mainProducts.length
    ? mainProducts
        .map((item) => {
          const qty = Number(item.qty || 0);
          const unit = Number(
            item.unitPrice || item.price || item.priceWithoutTax || 0,
          );
          const lineTotal = Number(
            item.totalNetLine || item.total || qty * unit || 0,
          );
          const children = childrenMap[item.id] || [];

          const addonsHTML = children
            .map(
              (c) => `
            <div class="line-addon">
              + ${c.productNameAr || c.productNameEn}
              (${Number(c.qty || 0)}) ${format(c.price || c.unitPrice || 0)}
            </div>`,
            )
            .join("");

          return `
          <tr>
            <td class="col-total">${format(lineTotal)}</td>
            <td class="col-price">${format(unit)}</td>
            <td class="col-qty">${qty}</td>
            <td class="col-product">
              <span class="line-product-ar">${item.productNameAr || ""}</span>
              <span class="line-product-en">${item.productNameEn || ""}</span>
              ${item.notes ? `<div class="line-notes">${item.notes}</div>` : ""}
              ${addonsHTML}
            </td>
          </tr>`;
        })
        .join("")
    : `<tr><td colspan="4" style="text-align:center; color:#777; padding:6px;">لا توجد أصناف</td></tr>`;

  const actualAmt = format(data.actualAmt);
  const taxAmt = format(data.taxAmt || data.tax);
  const priceBeforeTax = format(
    Number(data.actualAmt || 0) - Number(data.taxAmt || data.tax || 0),
  );

  const logoHTML = logo
    ? `<img src="${logo}" alt="logo" style="max-width:48px;max-height:48px;object-fit:contain;display:block;margin:0 auto 3px;" />`
    : `<div class="logo-placeholder">شعار</div>`;

  const barcodeImg = await generateQRCodeBase64(data.qrcode);
  // ── زيادة حجم الباركود ──────────────────────────────────────
  const qrSize = printerWidth <= 58 ? "130px" : "160px";
  const barcodeHTML = barcodeImg
    ? `<img src="${barcodeImg}" style="width:${qrSize};height:${qrSize};border:2px solid #111;" />`
    : "";

  const tobaccoRow = hasData(tobaccoFeeBeforeTax)
    ? `<tr>
         <td class="t-label">رسوم تقديم التبغ</td>
         <td class="t-value">${format(tobaccoFeeBeforeTax)}</td>
       </tr>`
    : "";

  return `
<!DOCTYPE html>
<html lang="ar" dir="rtl">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>
    @import url("https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@100..900&display=swap");

    :root { --ink:#111; --muted:#555; --border:#222; --paper:#fff; }
    * { box-sizing:border-box; }
    body {
      margin:0 auto; background:#fff; color:var(--ink);
      font-family:"Noto Kufi Arabic", sans-serif;
      font-size: clamp(8px, 2.5vw, 10px);
      line-height:1.3;
      padding: clamp(6px, 1.5vw, 10px) clamp(5px, 1.5vw, 8px) clamp(10px, 2vw, 16px);
      width: ${printerWidth}mm;
    }
    .logo { text-align:center; margin-bottom:4px; }
    .logo-placeholder {
      width:48px; height:48px; margin:0 auto 3px;
      border:1px dashed #999; border-radius:6px;
      display:flex; align-items:center; justify-content:center;
      font-size:8px; color:#888;
    }
    .receipt-title  { text-align:center; font-weight:800; font-size: clamp(11px, 3.5vw, 13px); margin:3px 0; }
    .receipt-sub    { text-align:center; font-weight:700; font-size: clamp(9px, 2.8vw, 11px); margin:1px 0; }
    .receipt-orderno{ text-align:center; font-weight:700; font-size: clamp(8.5px, 2.5vw, 10px); margin:4px 0 6px; }
    .info-full      { border:1px solid var(--border); padding:4px 5px; text-align:center; font-size: clamp(8px, 2.2vw, 9px); margin-bottom:4px; }
    .info-table     { width:100%; border-collapse:collapse; margin-bottom:4px; font-size: clamp(8px, 2.2vw, 9px); }
    .info-table td  { border:1px solid var(--border); padding:3px 5px; vertical-align:top; }
    .info-table .label { font-weight:700; width:38%; white-space:nowrap; }
    .token-box      { text-align:center; font-weight:800; font-size: clamp(16px, 5vw, 20px); border:2px solid var(--border); padding:4px 3px; margin:6px 0 8px; letter-spacing:2px; }
    .lines-table    { width:100%; border-collapse:collapse; font-size: clamp(7.5px, 2.2vw, 9px); margin-bottom:6px; }
    .lines-table th,
    .lines-table td { border:1px solid var(--border); padding:2px 3px; vertical-align:top; }
    .lines-table th { font-weight:800; text-align:center; background:#f8f9fa; font-size: clamp(7px, 2vw, 8.5px); }
    .col-total  { width:18%; text-align:center; }
    .col-price  { width:18%; text-align:center; }
    .col-qty    { width:14%; text-align:center; }
    .col-product{ text-align:start; }
    .line-product-ar { font-weight:700; display:block; }
    .line-product-en { font-size: clamp(7px, 2vw, 8px); color:#333; display:block; direction:ltr; text-align:right; }
    .line-notes  { font-size: clamp(7px, 2vw, 8px); color:var(--muted); margin-top:1px; }
    .line-addon  { font-size: clamp(7px, 2vw, 8px); padding-inline-start:6px; border-inline-start:2px solid #ccc; margin-top:2px; color:#333; }
    .totals-table    { width:100%; border-collapse:collapse; font-size: clamp(8px, 2.3vw, 9.5px); margin-bottom:6px; }
    .totals-table td { border:1px solid var(--border); padding:3px 5px; }
    .t-label { font-weight:600; width:62%; }
    .t-value { text-align:center; font-weight:600; direction:ltr; }
    .grand .t-label,
    .grand .t-value { font-weight:800; font-size: clamp(8.5px, 2.5vw, 10px); background:#f1f3f5; }
    .qr-wrap     { text-align:center; margin:8px 0 6px; }
    .footer-text { text-align:center; font-size: clamp(7.5px, 2.2vw, 9px); color:#333; white-space:pre-wrap; line-height:1.4; margin-top:4px; }
    @media print {
      body { padding:0; width:${printerWidth}mm; }
      @page { size:${printerWidth}mm auto; margin:2mm; }
    }
  </style>
</head>
<body>

  <div class="logo">${logoHTML}</div>

  <div class="receipt-title">فاتورة ضريبية مبسطة</div>
  ${hasData(data.header) ? `<div class="receipt-sub">${data.header}</div>` : ""}
  ${
    hasData(data.address)
      ? `<div class="receipt-sub">${data.address}</div>`
      : ""
  }
  ${
    hasData(taxNo)
      ? `<div class="receipt-sub">الرقم الضريبي: ${taxNo}</div>`
      : ""
  }

  <div class="receipt-orderno">رقم الفاتورة : ${data.orderNo || "-"}</div>

  ${hasData(data.address) ? `<div class="info-full">${data.address}</div>` : ""}

  <table class="info-table">
    <tbody>
      ${
        hasData(taxNo)
          ? `<tr><td class="label">الرقم الضريبي</td><td>${taxNo}</td></tr>`
          : ""
      }
      ${
        hasData(data.orderDate)
          ? `<tr><td class="label">الوقت:</td><td>${data.orderDate}</td></tr>`
          : ""
      }
      <tr><td class="label">العميل :</td><td>${data.customer ||
        "عميل نقدي"}</td></tr>
    </tbody>
  </table>

  <table class="info-table">
    <tbody>
      <tr>
        <td class="label">الطاولة</td>
        <td>${data.tableName || "-"}</td>
        <td class="label" style="width:22%">نوع الطلب</td>
        <td>${data.orderType || "-"}</td>
      </tr>
    </tbody>
  </table>

  ${hasData(data.tokenNo) ? `<div class="token-box">${data.tokenNo}</div>` : ""}

  <table class="lines-table">
    <thead>
      <tr>
        <th class="col-total">الاجمالي</th>
        <th class="col-price">السعر</th>
        <th class="col-qty">كمية</th>
        <th class="col-product">منتج</th>
      </tr>
    </thead>
    <tbody>${linesHTML}</tbody>
  </table>

  <table class="totals-table">
    <tbody>
      ${tobaccoRow}
      <tr><td class="t-label">السعر قبل الضريبة</td><td class="t-value">${priceBeforeTax}</td></tr>
      <tr><td class="t-label">ضريبة القيمة المضافة %15</td><td class="t-value">${taxAmt}</td></tr>
      <tr class="grand"><td class="t-label">الاجمالي</td><td class="t-value">${actualAmt}</td></tr>
    </tbody>
  </table>

  ${barcodeHTML ? `<div class="qr-wrap">${barcodeHTML}</div>` : ""}

  <div class="footer-text">${data.footer || "شكراً لزيارتكم"}</div>

</body>
</html>`;
};
